export default __webpack_public_path__ + "static/media/modular_engine.2aa11d8a.png";